import React from 'react';
import '../../styles/Sidebar.css';
import '../../styles/Dashboard.css';
import Job from '../../components/Job';

function JobPage() {
  return (
    <div className="dashboard-layout">
      <Job />
    </div>
  );
}

export default JobPage;